module.exports = __webpack_public_path__ + "media/images/pic/hero/clouds-e6d6cd0b6a1f16ffac71f6908517edae.png";